module.exports = __webpack_public_path__ + "static/media/icon_complete.70b9bc22.svg";